import { useEffect, useState } from 'react'
import { podpislonIntegrationApi } from '@/api'
import { isPodpislonIntegrationReady } from './sendForSignature.utils'

export const usePodpislonReady = () => {
  const [podpislonReady, setPodpislonReady] = useState(false)
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    let isMounted = true

    podpislonIntegrationApi
      .getConfig()
      .then((res) => {
        if (!isMounted) return
        const payload = res.data
        if (payload.status === 'success' && payload.data?.fields) {
          setPodpislonReady(isPodpislonIntegrationReady(payload.data.fields))
        } else {
          setPodpislonReady(false)
        }
      })
      .catch(() => {
        if (isMounted) {
          setPodpislonReady(false)
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsChecking(false)
        }
      })

    return () => {
      isMounted = false
    }
  }, [])

  return { podpislonReady, isCheckingPodpislon: isChecking }
}
